const OVERLAY_CLASS = 'mn-overlay'
const OVERLAY_ELEMENT = 'div'
const OVERLAY_STYLES = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    background: #000000 !important;
    opacity: 0.4 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 98 !important;
`

const sendEmit = (emit, detail) => {
  dispatchEvent(new CustomEvent(emit, { detail }))
}

class Overlay {
  create() {
    const elem = document.createElement(OVERLAY_ELEMENT)
    elem.classList.add(OVERLAY_CLASS)
    elem.style = OVERLAY_STYLES

    elem.addEventListener('click', this.close)
    window.addEventListener('keydown', this.escHandler.bind(this))

    return elem
  }

  append() {
    const elem = document.querySelector(`.${OVERLAY_CLASS}`)
    if (!elem) {
      document.body.appendChild(this.create())
    } else {
      elem.style.display = 'block'
    }
  }

  remove() {
    const elem = document.querySelector(`.${OVERLAY_CLASS}`)
    elem.style.display = 'none'
  }

  close() {
    sendEmit('gb-overlay-closed')
  }

  escHandler(e) {
    if (e.keyCode === 27) this.close()
  }
}

const overlay = new Overlay()

export default overlay
